import { object, string } from 'yup'

const CalculatorSchema = object().shape({
  loan_amount: string().required('Loan amount is required'),
  interest_rate: string().required('Interest rate is required'),
  loan_term: string().required('Loan term is required'),
  payment_freq: string().required('Payment freq is required')
})

export default CalculatorSchema
